// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/11/2023
 */

.TimeSelect_selectionContainer__MxO6k {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 0.5rem;
}

.TimeSelect_selectionContainer__MxO6k [class^="swiper-wrapper"] {
    height: auto;
}
.TimeSelect_selectionContainer__MxO6k [class^="swiper-button-"]{
    width: 5px;
    color: #5A9BD8;
}

.TimeSelect_selectionContainer__MxO6k [class^="swiper-button-"]::after{
    font-size: 1.2rem;
    font-weight: 600;
}

.TimeSelect_selectionContainer__MxO6k [class\$="-disabled"]{
    display: none;
}

.TimeSelect_selectionContainer__MxO6k [class\$="-prev"]{
    left: -0.8rem !important;
}
.TimeSelect_selectionContainer__MxO6k [class\$="-next"]{
    right: -0.5rem !important;
}

.TimeSelect_timeButton__wxdlv {
    border-radius: 0.5rem;
    border: 1px #5A9BD8 solid;
    width: 11rem !important;
    height: 2.5rem;
    margin: 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
}

.TimeSelect_timeButtonSelected__8I-GS {
    background-color: #5A9BD8;
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/TimeSelect.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 18/11/2023\r\n */\r\n\r\n.selectionContainer {\r\n    position: relative;\r\n    width: 90%;\r\n    margin: 0 auto;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-wrapper\"] {\r\n    height: auto;\r\n}\r\n.selectionContainer [class^=\"swiper-button-\"]{\r\n    width: 5px;\r\n    color: #5A9BD8;\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-button-\"]::after{\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.selectionContainer [class$=\"-disabled\"]{\r\n    display: none;\r\n}\r\n\r\n.selectionContainer [class$=\"-prev\"]{\r\n    left: -0.8rem !important;\r\n}\r\n.selectionContainer [class$=\"-next\"]{\r\n    right: -0.5rem !important;\r\n}\r\n\r\n.timeButton {\r\n    border-radius: 0.5rem;\r\n    border: 1px #5A9BD8 solid;\r\n    width: 11rem !important;\r\n    height: 2.5rem;\r\n    margin: 0 0.5rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n}\r\n\r\n.timeButtonSelected {\r\n    background-color: #5A9BD8;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionContainer": `TimeSelect_selectionContainer__MxO6k`,
	"timeButton": `TimeSelect_timeButton__wxdlv`,
	"timeButtonSelected": `TimeSelect_timeButtonSelected__8I-GS`
};
export default ___CSS_LOADER_EXPORT___;
